module.exports = __webpack_public_path__ + "assets/img/dzh-30.1610af38.gif";